import { useMutation } from "@tanstack/react-query";
import { sendQuote } from "../QuoteService";
import { showToast } from "../../../../common/Toaster/Toaster";

const useSendQuote = () =>
  useMutation({
    mutationFn: sendQuote,
    onSuccess: () => {
      showToast("Quote sent successfully", "success");
    },
    onError: (error) => {
      showToast(
        error?.response?.data?.error_message || "Error while sending quote",
        "error"
      );
    },
  });

export default useSendQuote;
